import { createFileRoute } from "@tanstack/react-router";
import { MessageThreadView } from "@/routes/_authenticated/messages/$bookingId";

export const Route = createFileRoute("/_authenticated/partner/messages/$bookingId")({
  head: () => ({
    meta: [
      { title: "Partner conversation — Shields" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: PartnerMessageThread,
});

function PartnerMessageThread() {
  const { bookingId } = Route.useParams();
  return <MessageThreadView bookingId={bookingId} workspace="partner" />;
}
